export enum EventDestination {
  Amplitude = 'amplitude',
  Google = 'google',
  Facebook = 'facebook',
  Firebase = 'firebase',
  Appsflyer = 'appsflyer',
}
